<template>
  <div>
    <div class="top">
      <div class="topleft" @click="$router.push('/rightimfo')" v-if="right">
        <van-icon name="manager-o" color="#ffffff" />教师
      </div>
      <div class="title">教育缴费</div>
      <div class="topright" @click="$router.push('/his')">缴费记录</div>
    </div>
    <div class="contaa jh-page">
      <van-image
        v-if="onepic"
        class="banner"
        width="100%"
        height="5rem"
        fit="cover"
        :src="onehead + onepic"
        @click="goother"
      />
      <!-- <van-image
          width="10rem"
          height="5rem"
          fit="fill"
          src="../../assets/logo.png"
          @click="goother"
        /> -->
      <div class="jh-section-title">学生信息</div>
      <div class="top3 jh-card student-card">
        <van-field
          v-model="subdata.name"
          label="学生"
          placeholder="请输入学生姓名"
          required
          :border="false"
        />
        <van-field
          v-model="subdata.idcard"
          label="身份证号码"
          placeholder="请输入身份证号码"
          required
          :border="false"
        />

        <div class="tix">注意：请输入正确的学生信息，以免缴费错误！</div>

        <div class="onebtnbox">
          <van-button
            color="#dd0000"
            class="surebtn"
            size="normal"
            block
            round
            @click="searchpay"
            >缴费查询</van-button
          >
        </div>
        <div class="xieyi">
          <van-checkbox
            v-model="agreeChecked"
            checked-color="#dd0000"
            @change="onAgreeChange"
            >同意</van-checkbox
          >
          <span class="jh-link" @click="gotohelp"
            >《用户服务协议》、《隐私政策》</span
          >
        </div>
      </div>
      <div class="jh-section-title section-gap">缴费信息</div>

      <div class="top4 jh-card list-card">
        <div v-if="numdata.length > 0">
          <van-cell-group
            v-for="(item, index) in numdata"
            :key="index"
            :border="false"
          >
            <van-cell
              v-if="item.status == '未支付'"
              class="onecell"
              :title="item.title"
              :label="paymentCellLabel(item)"
              @click="gomypaymentimfo(item)"
            >
              <template #right-icon>
                <div class="cell-status">
                  <van-tag type="danger">{{ item.status }}</van-tag>
                  <van-icon name="arrow" />
                </div>
              </template>
            </van-cell>
            <van-cell
              v-if="item.status == '已支付'"
              class="onecell"
              :title="item.title"
              :label="paymentCellLabel(item)"
              @click="gopay(item)"
            >
              <template #right-icon>
                <div class="cell-status">
                  <van-tag type="success">{{ item.status }}</van-tag>
                  <van-icon name="arrow" />
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
        <div v-else class="empty-wrap">
          <van-empty description="暂无支付数据" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/Api/axios";
import { Toast } from "vant";

export default {
  data() {
    return {
      onehead: window.location.origin,
      authTimer: null,
      onepic: "",
      oneurl: "",
      numdata: [],
      subdata: {
        name: "",
        idCard: "",
        class: "",
      },
      agreeChecked: false,
      radio: false,
      allprice: 0,
      orid: "",
      payitems: [],
      right: false,
      newflag: true,
    };
  },

  created() {
    this.geturl();
    this.gethisa();
    this.getpic();
    this.agreeChecked = !!localStorage.getItem("agreeSomeOne");
  },

  activated() {
    this.trySearchAfterAgree();
  },

  mounted() {
    this.trySearchAfterAgree();
  },

  methods: {
    trySearchAfterAgree() {
      if (sessionStorage.getItem("needSearchAfterAgree") === "1") {
        sessionStorage.removeItem("needSearchAfterAgree");
        this.agreeChecked = true;
        this.searchpay();
      }
    },
    onAgreeChange(val) {
      if (val) {
        localStorage.setItem("agreeSomeOne", "true");
      } else {
        localStorage.removeItem("agreeSomeOne");
      }
    },
    gotohelp() {
      this.$router.push("/agreement");
    },
    getpic() {
      this.fetchget("/api/app/ad/randomAd").then((res) => {
        if (res.code < 0) {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        } else {
          // console.log(res);
          this.onepic = res.img;
          this.oneurl = res.url;
        }
      });
    },
    //外部页面
    goother() {
      window.open("https://" + this.oneurl);
    },
    gomypaymentimfo(item) {
      this.$router.push({
        path: "/mypaymentimfo",
        query: { id: item.paymentid, studentid: item.studentid },
      });
    },
    async gopay(item) {
      Toast.loading({ message: "加载收据...", forbidClick: true });
      try {
        const res = await axios.get("/api/order/mypaymentpdf", {
          params: {
            id: item.paymentid,
            studentId: item.studentid,
          },
          responseType: "blob",
        });
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
        setTimeout(() => URL.revokeObjectURL(url), 60 * 1000);
      } catch (e) {
        this.$notify({
          type: "danger",
          message: "打开缴费收据失败，请稍后再试",
          color: "#ad0000",
          background: "#ffe1e1",
        });
      } finally {
        Toast.clear();
      }
    },
    gethisa() {
      if (localStorage.getItem("name") || localStorage.getItem("idCard")) {
        this.$set(this.subdata, "name", localStorage.getItem("name") || "");
        this.$set(this.subdata, "idcard", localStorage.getItem("idCard") || "");
        this.$set(this.subdata, "class", localStorage.getItem("class") || "");
        this.orid = localStorage.getItem("orgId") || "";
      }
    },
    geturl() {
      if (process.env.NODE_ENV != "development") {
        let that = this;
        this.authTimer = setInterval(() => {
          var loginUserStr = localStorage.getItem("APPLOGINUSER");
          if (loginUserStr && loginUserStr != "") {
            var loginUser = JSON.parse(loginUserStr);
            console.log("loginUser", loginUser);
            this.fetchpost("/api/account/appLogin", loginUser)
              .then((res) => {
                if(res.code>0){
                localStorage.setItem("token", res.data.token);
                that.right =
                  res.data.permission.indexOf("Payment.Default.List") >= 0;
                }else {
                    this.$notify({
                  type: "danger",
                  message: res.msg,
                  color: "#ad0000",
                  background: "#ffe1e1",
                });
                }
              
              })
            

            clearInterval(this.authTimer);
          }
        }, 500);

        // let token = url.href.split("scToken=")[1];
        //
        // if (token) {
        //   this.fetchget("api/Account/tokenlogin", { token: token }).then(
        //     (res) => {
        //
        //     }
        //   );
        // } else {
        //   this.$router.push("/empty");
        //   this.$notify({
        //     type: "danger",
        //     message: "请先登录",
        //     color: "#ad0000",
        //     background: "#ffe1e1",
        //   });
        // }
      } else {
        this.right = localStorage.getItem("Payment.Default.List");
      }
    },
    searchpay() {
      this.payitems = [];

      if (!this.subdata.name) {
        this.$notify({
          type: "danger",
          message: "请填写学生姓名",
          color: "#ad0000",
          background: "#ffe1e1",
        });
        return;
      }
      if (!this.subdata.idcard) {
        this.$notify({
          type: "danger",
          message: "请填写学生身份证号",
          color: "#ad0000",
          background: "#ffe1e1",
        });
        return;
      }

      const params = {
        name: this.subdata.name,
        idCard: this.subdata.idcard,
      };
      if (this.orid) {
        params.orgId = this.orid;
      }
      this.doSearchPayment(params);
    },
    paymentCellLabel(item) {
      if (!item.orgInfo) return "";
      return (
        (item.orgInfo.extraProperties &&
          item.orgInfo.extraProperties.NamePath) ||
        item.orgInfo.displayName ||
        ""
      );
    },
    doSearchPayment(params) {
      this.fetchpost("/api/Order/mypayment", params).then((res) => {
        if (res.code > 0) {
          this.numdata = Array.isArray(res.data) ? res.data : [];
          sessionStorage.setItem("name", this.subdata.name);
          sessionStorage.setItem("idCard", this.subdata.idcard);
          if (this.orid) {
            sessionStorage.setItem("orgId", this.orid);
            sessionStorage.setItem("class", this.subdata.class);
            localStorage.setItem("orgId", this.orid);
            localStorage.setItem("class", this.subdata.class);
          }
          localStorage.setItem("name", this.subdata.name);
          localStorage.setItem("idCard", this.subdata.idcard);
          if (this.numdata.length === 0 && res.msg) {
            this.$notify({
              type: "danger",
              message: res.msg,
              color: "#ad0000",
              background: "#ffe1e1",
            });
          }
        } else {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$brand: #dd0000;
$bg: #f3f5f9;
$text: #0f172a;
$muted: #64748b;
$border: #e2e8f0;
$radius: 10px;
$shadow: 0 4px 16px rgba(15, 23, 42, 0.06);

.jh-page {
  min-height: calc(100vh - 44px);
  padding: 14px;
  background: $bg;
  box-sizing: border-box;
}

.jh-section-title {
  display: flex;
  align-items: center;
  margin: 4px 4px 10px;
  font-size: 15px;
  font-weight: 600;
  color: $text;

  &::before {
    content: "";
    width: 4px;
    height: 14px;
    margin-right: 8px;
    border-radius: 4px;
    background: $brand;
  }
}

.section-gap {
  margin-top: 18px;
}

.jh-card {
  background: #fff;
  border-radius: $radius;
  border: 1px solid $border;
  box-shadow: $shadow;
  overflow: hidden;
}

.banner {
  display: block;
  margin-bottom: 14px;
  border-radius: $radius;
  overflow: hidden;
}

.onecell {
  min-height: 50px;

  .van-cell__value {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
  }
}

.cell-status {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 2px;
}

.student-card {
  padding-bottom: 4px;
}

.list-card {
  padding: 0;
  min-height: 100px;
}

.empty-wrap {
  padding: 24px 0;
}

.xieyi {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin: 0 12px 14px;
  padding: 8px 6px 4px;
  border-top: 1px solid $border;
  color: $muted;
  font-size: 12px;
}

.jh-link {
  color: $brand;
  font-size: 12px;
  cursor: pointer;
}

.contaa {
  overflow-y: auto;
}

.contaa::-webkit-scrollbar {
  display: none;
}

.hidden {
  display: none;
}

.full {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.public-web-container,
.wechat-web-container,
.desktop-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.public-web-container a {
  margin-top: 30px;
}

.wechat-web-container wx-open-launch-weapp {
  position: absolute;
  bottom: 40%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.desktop-web-container p {
  position: absolute;
  top: 40%;
}

.public-web-jump-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 24px;
}

.public-web-jump-link {
  cursor: pointer;
  text-decoration: none;
  color: rgb(108, 125, 162);
  transition: opacity 0.2s ease-out;

  &:hover {
    opacity: 0.8;
  }
}

.launch-weapp-button {
  width: 200px;
  height: 45px;
  text-align: center;
  font-size: 17px;
  display: block;
  margin: 0 auto;
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  background-color: #07c160;
  color: #fff;
  cursor: pointer;
}

.top {
  width: 100%;
  height: 44px;
  background-color: $brand;
  min-height: 44px;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
  position: relative;

  .topright {
    font-size: 12px;
    position: absolute;
    right: 15px;
    top: 10px;
    line-height: 20px;
    height: 20px;
    width: 70px;
    border: 1px solid #ffffff;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease-out;

    &:active {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .topleft {
    font-size: 12px;
    position: absolute;
    left: 15px;
    top: 0;
    cursor: pointer;
  }
}

.top1 {
  width: 100%;
  height: 120px;
  background-color: #ffffff;
  margin-bottom: 7px;
}

.top2 {
  display: none;
}

.top3 {
  width: 100%;
  min-height: auto;
  background: transparent;
  margin-bottom: 0;
  position: relative;
  padding-bottom: 12px;
}

.top4 {
  width: 100%;
  box-sizing: border-box;
  background: transparent;
  padding: 0;
  position: relative;

  .allcheckradio {
    margin-left: 17px;
    font-size: 15px;
  }

  .tocheck {
    font-size: 15px;
    margin-bottom: 15px;
  }

  .heji {
    width: 100%;
    height: 80px;
    background-color: #fffafa;
    line-height: 80px;
    font-size: 16px;
    color: $text;
    text-align: center;
    border-top: 1px solid $border;

    .hejinum {
      font-size: 28px;
      font-weight: 700;
      letter-spacing: 1px;
      color: $brand;
    }

    .yuan {
      font-size: 14px;
      font-weight: normal;
      color: $brand;
    }
  }
}

.onebtnbox {
  width: 100%;
  padding: 8px 16px 4px;
  box-sizing: border-box;
}

.surebtn {
  width: 100%;
  position: static;
  margin: 0;
  left: auto;
}

.tix {
  font-size: 12px;
  width: auto;
  height: auto;
  line-height: 1.5;
  text-align: center;
  margin: 8px 16px 12px;
  padding: 8px 10px;
  color: $brand;
  background: #fff1f1;
  border-radius: 8px;
}

@media (prefers-reduced-motion: reduce) {
  .public-web-jump-link,
  .top .topright {
    transition: none;
  }
}
</style>